import { useEffect, useRef, useCallback } from 'react'
import { createPusherInstance } from 'utils/pusher'

// `channelName` boleh string (1 channel) atau array (banyak channel, 1 koneksi Pusher).
export const usePusher = (channelName) => {
  const pusherRef = useRef(null)
  const channelRef = useRef(null)
  const channelsRef = useRef({})

  // Gabung nama channel jadi satu key string supaya effect tidak jalan ulang
  // tiap render saat pemanggil mengirim array baru.
  const channelKey = Array.isArray(channelName) ? channelName.join('|') : channelName

  useEffect(() => {
    const names = channelKey ? channelKey.split('|') : []

    // Saat realtime off (tidak ada channel), jangan bikin/connect Pusher sama sekali.
    if (!names.length) {
      return undefined
    }

    const pusher = createPusherInstance()
    pusherRef.current = pusher

    const channels = {}
    names.forEach((name) => {
      channels[name] = pusher.subscribe(name)
    })
    channelsRef.current = channels
    // `channelRef` tetap menunjuk channel pertama, supaya pemakai lama tidak berubah.
    channelRef.current = channels[names[0]]

    // Cleanup function to unsubscribe and disconnect on unmount
    return () => {
      names.forEach((name) => {
        try {
          pusher.unsubscribe(name)
        } catch (error) {
          console.error('Error unsubscribing from channel:', error)
        }
      })
      channelsRef.current = {}
      channelRef.current = null
      if (pusherRef.current) {
        try {
          // Cek state connection sebelum disconnect untuk menghindari warning
          const { state } = pusher.connection
          if (state !== 'disconnected' && state !== 'disconnecting') {
            pusher.disconnect()
          }
          pusherRef.current = null
        } catch (error) {
          console.error('Error disconnecting Pusher:', error)
        }
      }
    }
  }, [channelKey])

  const reconnectPusher = useCallback(() => {
    if (pusherRef.current) {
      try {
        const { state } = pusherRef.current.connection
        // Hanya disconnect jika connection masih aktif
        if (state !== 'disconnected' && state !== 'disconnecting') {
          pusherRef.current.disconnect() // Memutuskan koneksi Pusher
        }
        // Token terbaru otomatis dipakai: auth channel mengambil token setiap subscribe (utils/pusher)
        pusherRef.current.connect() // Menginisialisasi kembali koneksi Pusher dengan pengaturan baru
      } catch (error) {
        console.error('Error reconnecting Pusher:', error)
      }
    }
  }, [])

  return { channelRef, channelsRef, reconnectPusher }
}
